import { render } from "./Step2RequiredData.vue?vue&type=template&id=01d06be8&scoped=true&ts=true"
import script from "./Step2RequiredData.vue?vue&type=script&lang=ts"
export * from "./Step2RequiredData.vue?vue&type=script&lang=ts"

import "./Step2RequiredData.vue?vue&type=style&index=0&id=01d06be8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d06be8"]])

export default __exports__